<template>
  <base-modal
    :reference="'editBus_' + busId"
    :title="'Editar bus'"
    :acceptAction="editBus"
    :cancelActionText="'Cerrar'"
    :size="'md'"
  >
    <template v-slot:body v-if="show">
     
      <div class="d-block ">
        <form>
          <div class="d-flex justify-content-center w-100 mt-4">
            <div class="d-flex flex-column align-items-sm-baseline">
              <label>Nombre *</label>
              <b-form-input
                style="width: 17vw; border: 1px solid #999 !important;"
                v-model="bus.nameBus"
                placeholder="Inserte un nombre para el bus"
              ></b-form-input>
              <span v-if="bus.nameBus == ''" class="text-danger font-weight-bold">
                El nombre és obligatorio
              </span>
            </div>
          </div>
          <div class="d-flex justify-content-center w-100 mt-4">
            <div class="d-flex flex-column align-items-sm-baseline">
              <label>Plazas *</label>
              <b-form-input
                style="width: 17vw; border: 1px solid #999 !important;"
                v-model="bus.sizeBus"
                placeholder="Inserte número de plazas"
              ></b-form-input>
              <span v-if="bus.sizeBus == ''" class="text-danger font-weight-bold">
                El número de plazas és obligatorio
              </span>
            </div>
          </div>
          <div class="d-flex justify-content-center w-100 mt-4">
            <div class="d-flex flex-column align-items-sm-baseline">
              <label>Número</label>
              <b-form-input
                style="width: 17vw; border: 1px solid #999 !important;"
                v-model="bus.numberBus"
                type="number"
                placeholder="Inserte número de bus"
              ></b-form-input>
            </div>
          </div>
          <div class="d-flex justify-content-center w-100 mt-4">
            <div class="d-flex flex-column align-items-sm-baseline">
              <label>Nombre de la compañía de buses</label>
              <b-form-select
                v-model="bus.bus_company"
                style="width: 17vw;"
              >
                <option :value="0">Seleccione una compañía de buses</option>
                <option
                  v-for="company in busCompanies"
                  :key="company.id"
                  :label="company.name"
                  :value="company.id"
                >
                  {{ company.full_name }}
                </option>
              </b-form-select>
            </div>
          </div>
          <div class="d-flex justify-content-center w-100 mt-4">
            <div class="d-flex flex-column align-items-sm-baseline" style="width: 17vw;">
              <label>Tarifa de bus</label>
              <b-form-select
                v-model="bus.bus_fare_type"
                style="width: 17vw;"
              >
                <option :value="0">Seleccione una tarifa de bus</option>
                <option
                  v-for="fare in busFareTypes"
                  :key="fare.id"
                  :label="fare.name"
                  :value="fare.id"
                >
                  {{ fare.name }}
                </option>
              </b-form-select>
            </div>
          </div>
          <div class="d-flex justify-content-center w-100 mt-4">
            <div class="d-flex flex-column align-items-sm-baseline" style="width: 17vw;">
              <label>Usos del bus *</label>
              <b-form-checkbox
                  :id="'used_excursion'"
                  v-model="bus.used_excursion"
                  :name="'used_excursion'"
                  class="my-2"
              >
                  Usado para excursión
              </b-form-checkbox>

              <b-form-checkbox
                  :id="'used_pickup'"
                  v-model="bus.used_pickup"
                  :name="'used_pickup'"
                  class="my-2"
              >
                  Usado para recogidas
              </b-form-checkbox>

              <b-form-checkbox
                  :id="'used_return'"
                  v-model="bus.used_return"
                  :name="'used_return'"
                  class="my-2"
              >
                  Usado para dejadas
              </b-form-checkbox>
              <span v-if="!bus.used_excursion && !bus.used_pickup && !bus.used_return" class="alert-danger alert font-weight-bold">
                Al menos uno de los checks tiene que estar marcado
              </span>
            </div>
          </div>
          
        </form>
      </div>
    </template>
    <!-- <template v-slot:accept-action>
        <b-button pill variant="dark" @click="editBus" class="ml-3">
          <i class="fa fa-floppy-o mr-1" aria-hidden="true"></i>Editar
        </b-button>
    </template> -->
  </base-modal>
  <!-- <div>
    {{busId}}
    <div :disabled="disabledButton" @click="showModal">
      <i class="fa fa-edit mr-2"></i>Editar
    </div>
    <b-modal :ref="'editbus_' + busId" :id="'editbus_' + busId" hide-footer title="Editar bus">
      {{busId}}
      <div class="d-block text-center">
        <form>
          <div class="d-flex justify-content-center w-100">
            <div class="d-flex flex-column align-items-sm-baseline">
              <label>Nombre Bus</label>
              <b-form-input
                style="width: 17vw;"
                v-model="nameBus"
                placeholder="Inserte un nombre para el bus"
              ></b-form-input>
            </div>
          </div>
          <div class="d-flex justify-content-center w-100">
            <div class="d-flex flex-column align-items-sm-baseline">
              <label>Nº Bus</label>
              <b-form-input
                style="width: 17vw;"
                v-model="numberBus"
                placeholder="Inserte un nombre para el bus"
              ></b-form-input>
            </div>
          </div>
          <div class="d-flex justify-content-center w-100">
            <div class="d-flex flex-column align-items-sm-baseline">
              <label>Capacidad Bus</label>
              <b-form-input
                style="width: 17vw;"
                v-model="sizeBus"
                placeholder="Inserte un nombre para el bus"
              ></b-form-input>
            </div>
          </div>
        </form>
      </div>
      <div class="mt-3 text-center">
        <b-button pill variant="ligth" @click="hideModal">
          <i class="fa fa-ban mr-1" aria-hidden="true"></i>Cancelar
        </b-button>
        <b-button pill variant="dark" @click="editBus" class="ml-3">
          <i class="fa fa-floppy-o mr-1" aria-hidden="true"></i>Editar
        </b-button>
      </div>
    </b-modal>
  </div> -->
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import BaseModal from '../../../Excursions/Booking/Modal/BaseModal';

export default {
  components: {
      BaseModal,
  },
  props: {
    busId: {
      type: Number,
      required: true,
    }
  },
  data() {
    return {
      bus: {
        nameBus: '',
        numberBus: null,
        sizeBus: '',
        used_excursion: true,
        used_pickup: false,
        used_return: false,
        bus_company: '',
        bus_fare_type: '',
      },
      busNameBefore: '', // to control when name changes, to dispatch booking table refresh to update bus name on tables
      show: false,
    };
  },
  async mounted() {
    
    this.$root.$on('bv::modal::show', async (bvEvent, modalId) => {
      if ( modalId === 'editBus_' + this.busId ) {
        this.$store.dispatch("buscompanies/retrieveBusCompanies")
        this.$store.dispatch("busFareTypes/retrieveBusFareTypes")
        let bus = {}
        if ( this.activeTab === 'Excursions')
          bus = await this.$store.getters.busExcursion(this.busId)
        else if ( this.activeTab === 'Pickups')
          bus = await this.$store.getters.busPickup(this.busId)
        else if ( this.activeTab === 'Returns')
          bus = await this.$store.getters.busReturn(this.busId)
        else
          console.error("activeTab unrecognized")
        
        this.bus = {
          nameBus: bus.name,
          numberBus: bus.number,
          sizeBus: bus.max_size,
          used_excursion: bus.used_excursion,
          used_pickup: bus.used_pickup,
          used_return: bus.used_return,
          bus_company: bus.bus_company,
          bus_fare_type: bus.bus_fare_type,
        }
        console.log("bus edit info", this.bus, bus)
        this.show = true
      }
      
    })
  },
  methods: {
    async editBus() {
      if ((!this.bus.used_excursion && !this.bus.used_pickup && !this.bus.used_return) || this.bus.nameBus == '' || this.bus.sizeBus == '') {
        this.$notify({
          group: "foo",
          title: "Datos incompletos",
          text: "No se puede crear el nuevo bus por falta de datos",
          type: "error"
        });
        return
      }
      let payload = {
        id: this.busId,
        data: {
          name: this.bus.nameBus,
          number: this.bus.numberBus,
          max_size: this.bus.sizeBus,
          used_excursion: this.bus.used_excursion,
          used_pickup: this.bus.used_pickup,
          used_return: this.bus.used_return,
          bus_company: this.bus.bus_company,
          bus_fare_type: this.bus.bus_fare_type,
        }
      };

      try {
        await this.$store.dispatch("buses/updateBus", payload);
      } catch (ex) {
        this.error = "Failed to load data";
      } finally {

        if ( this.bus.name !== this.busNameBefore ) {
          // dispatch bookings table update
          if ( this.activeTab === 'Excursions') 
            this.$store.dispatch("bookings/loadBookingsByActivity")
          else if ( this.activeTab === 'Pickups')
            this.$store.dispatch("bookings/loadBookingsByStop")
        }

        this.$bvModal.hide('editBus_' + this.busId);

        this.$notify({
          group: "foo",
          title: "Bus editado",
          text: "Se ha editado con éxito el bus seleccionado",
          type: "info"
        });
      }
    },
    // showModal() {
    //   console.log("refs", this.$refs)
    //   console.log("id", this.busId)
    //   this.$refs['editbus_' + this.busId].show();
    // },
    // hideModal() {
    //   this.$refs['editbus_' + this.busId].hide();
    // }
  },
  computed: {
    ...mapGetters(["activeTab", "busCompanies", "busFareTypes"]),
  }
};
</script>
